<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    @click:outside="cancel"
  >
    <v-card light>
      <v-btn
        class="float-right"
        icon
        @click="cancel"
      >
        <v-icon>close</v-icon>
      </v-btn>
      <v-card-title class="px-8 pt-12"> Edit {{ isType ? 'Type' : 'Page' }} </v-card-title>
      <v-card-text class="px-8">
        <v-form
          ref="form"
          v-model="valid"
        >
          <v-row>
            <v-col
              v-if="!isType"
              cols="12"
            >
              <v-text-field
                v-model="item.slug"
                label="Url Slug"
                outlined
                persistent-hint
                :disabled="!!item.published"
                :hint="
                  item.published
                    ? 'A published page keeps its url.'
                    : 'No leading slash — e.g. for/real-estate-agents'
                "
                :rules="item.published ? [] : [$rules.required]"
              />
            </v-col>
            <v-col cols="12">
              <v-textarea
                :height="isType ? 'calc(100vh - 200px)' : 'calc(100vh - 290px)'"
                hide-details
                no-resize
                v-model="item.pageJson"
                label="Json"
                outlined
              />
            </v-col>
            <v-col cols="auto">
              <v-btn
                x-large
                :loading="saving"
                @click="save"
              >
                Save
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { cloneDeep } from 'lodash';
export default {
  name: 'EditContentPageDialog',
  data: () => ({
    dialog: false,
    saving: false,
    valid: false,
    item: {},
    isType: false
  }),
  computed: {},
  methods: {
    cancel() {
      this.dialog = false;
    },
    show(id) {
      this.dialog = true;
      this.saving = false;
      this.isType = false;
      this.$store.dispatch('content/getPage', id).then((data) => {
        this.item = data;
      });
    },
    showType(item, isType) {
      this.dialog = true;
      this.saving = false;
      this.isType = true;
      this.item = cloneDeep(item);
    },
    save() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        this.$store
          .dispatch(this.isType ? 'content/savePageTypeJson' : 'content/savePageJson', this.item)
          .then(() => {
            this.cancel();
          })
          .catch((error) => {
            this.logError(error);
          })
          .finally(() => {
            this.saving = false;
          });
      }
    }
  }
};
</script>
